__webpack_require__.p = "/wp-content/plugins/kurzanfrage/assets/";